import { render } from "./avatar-element-slide-selector.vue?vue&type=template&id=d472adb4"
import script from "./avatar-element-slide-selector.vue?vue&type=script&lang=js"
export * from "./avatar-element-slide-selector.vue?vue&type=script&lang=js"

import "./avatar-element-slide-selector.vue?vue&type=style&index=0&id=d472adb4&lang=css"

import exportComponent from "F:\\DEV\\estimationpoker\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__